import { gql } from "@apollo/client";

export const STARTUPS = gql`
  query {
    startups(
      sort: "id:desc"
      pagination: { page: 1, pageSize: 10000 }
      filters: { EMAIL_CONFIRMED_AT: { notNull: true } }
    ) {
      data {
        id
        attributes {
          NAM
          HDQ
          EMAIL_CONFIRMED_AT
          MAIL_COMPANY
          website
          MOD {
            data {
              id
              attributes {
                value
              }
            }
          }
          ECO {
            data {
              id
              attributes {
                value
              }
            }
          }
          IND {
            data {
              id
              attributes {
                value
              }
            }
          }
          LEG {
            data {
              id
              attributes {
                value
              }
            }
          }
          LOC {
            data {
              attributes {
                longitude
                latitude
                name
              }
            }
          }
        }
      }
    }
  }
`;

export const PARTICIPANT_PROFILES = gql`
  query {
    participantProfiles(
      sort: "id:desc"
      pagination: { page: 1, pageSize: 10000 }
    ) {
      data {
        id
        attributes {
          GDR {
            data {
              id
              attributes {
                value
              }
            }
          }
        }
      }
    }
  }
`;

export const STARTUPDATA_HALBJAHR = gql`
  query {
    startupdataHalbjahrs(pagination: { page: 1, pageSize: 10000 }) {
      data {
        id
        attributes {
          RVN {
            data {
              id
              attributes {
                value
              }
            }
          }
          RVN_1 {
            data {
              id
              attributes {
                value
              }
            }
          }
          PFT {
            data {
              id
              attributes {
                value
              }
            }
          }
          PFT_2
          BST_f {
            data {
              id
              attributes {
                value
              }
            }
          }
          BST_c {
            data {
              id
              attributes {
                value
              }
            }
          }
          CUS_E
          CUS_N
          CUS_B
        }
      }
    }
  }
`;

export const INDUSTRIES = gql`
  query {
    indRanges(pagination: { page: 1, pageSize: 10000 }) {
      data {
        id
        attributes {
          value
        }
      }
    }
  }
`;

export const LEGAL_FORMS = gql`
  query {
    legRanges(pagination: { page: 1, pageSize: 10000 }) {
      data {
        id
        attributes {
          value
        }
      }
    }
  }
`;

export const BUSINESS_MODELS = gql`
  query {
    modRanges(pagination: { page: 1, pageSize: 10000 }) {
      data {
        id
        attributes {
          value
        }
      }
    }
  }
`;

export const ECOSYSTEMS = gql`
  query {
    ecoRanges(pagination: { page: 1, pageSize: 10000 }) {
      data {
        id
        attributes {
          value
        }
      }
    }
  }
`;

export const GENDERS = gql`
  query {
    gdrRanges(pagination: { page: 1, pageSize: 10000 }) {
      data {
        id
        attributes {
          value
        }
      }
    }
  }
`;

export const EDUCATIONS = gql`
  query {
    edcRanges(pagination: { page: 1, pageSize: 10000 }) {
      data {
        id
        attributes {
          value
        }
      }
    }
  }
`;
export const MARITALS = gql`
  query {
    mstRanges(pagination: { page: 1, pageSize: 10000 }) {
      data {
        id
        attributes {
          value
        }
      }
    }
  }
`;

export const ACADEMICS = gql`
  query {
    abcRanges(pagination: { page: 1, pageSize: 10000 }) {
      data {
        id
        attributes {
          value
        }
      }
    }
  }
`;

export const STARTUPROLES = gql`
  query {
    rolRanges(pagination: { page: 1, pageSize: 10000 }) {
      data {
        id
        attributes {
          value
        }
      }
    }
  }
`;

export const ENG1ROLES = gql`
  query {
    eng1Ranges(pagination: { page: 1, pageSize: 10000 }) {
      data {
        id
        attributes {
          value
        }
      }
    }
  }
`;

export const ENG2ROLES = gql`
  query {
    eng2Ranges(pagination: { page: 1, pageSize: 10000 }) {
      data {
        id
        attributes {
          value
        }
      }
    }
  }
`;

export const ENG3ROLES = gql`
  query {
    eng3Ranges(pagination: { page: 1, pageSize: 10000 }) {
      data {
        id
        attributes {
          value
        }
      }
    }
  }
`;

export const ENG4ROLES = gql`
  query {
    eng4Ranges(pagination: { page: 1, pageSize: 10000 }) {
      data {
        id
        attributes {
          value
        }
      }
    }
  }
`;

export const ENG5ROLES = gql`
  query {
    eng5Ranges(pagination: { page: 1, pageSize: 10000 }) {
      data {
        id
        attributes {
          value
        }
      }
    }
  }
`;

export const ENG6ROLES = gql`
  query {
    eng6Ranges(pagination: { page: 1, pageSize: 10000 }) {
      data {
        id
        attributes {
          value
        }
      }
    }
  }
`;

export const ENG7ROLES = gql`
  query {
    eng7Ranges(pagination: { page: 1, pageSize: 10000 }) {
      data {
        id
        attributes {
          value
        }
      }
    }
  }
`;

export const ENG8ROLES = gql`
  query {
    eng8Ranges(pagination: { page: 1, pageSize: 10000 }) {
      data {
        id
        attributes {
          value
        }
      }
    }
  }
`;

export const DO1ROLES = gql`
  query {
    dO1Ranges(pagination: { page: 1, pageSize: 10000 }) {
      data {
        id
        attributes {
          value
        }
      }
    }
  }
`;

export const DO2ROLES = gql`
  query {
    dO2Ranges(pagination: { page: 1, pageSize: 10000 }) {
      data {
        id
        attributes {
          value
        }
      }
    }
  }
`;

export const DO3ROLES = gql`
  query {
    dO3Ranges(pagination: { page: 1, pageSize: 10000 }) {
      data {
        id
        attributes {
          value
        }
      }
    }
  }
`;

export const DP1ROLES = gql`
  query {
    dP1Ranges(pagination: { page: 1, pageSize: 10000 }) {
      data {
        id
        attributes {
          value
        }
      }
    }
  }
`;

export const DP2ROLES = gql`
  query {
    dP2Ranges(pagination: { page: 1, pageSize: 10000 }) {
      data {
        id
        attributes {
          value
        }
      }
    }
  }
`;

export const DP3ROLES = gql`
  query {
    dP3Ranges(pagination: { page: 1, pageSize: 10000 }) {
      data {
        id
        attributes {
          value
        }
      }
    }
  }
`;

export const DAF1ROLES = gql`
  query {
    daf1Ranges(pagination: { page: 1, pageSize: 10000 }) {
      data {
        id
        attributes {
          value
        }
      }
    }
  }
`;

export const DAF2ROLES = gql`
  query {
    daf2Ranges(pagination: { page: 1, pageSize: 10000 }) {
      data {
        id
        attributes {
          value
        }
      }
    }
  }
`;

export const DAF3ROLES = gql`
  query {
    daf3Ranges(pagination: { page: 1, pageSize: 10000 }) {
      data {
        id
        attributes {
          value
        }
      }
    }
  }
`;

export const BED1ROLES = gql`
  query {
    bed1Ranges(pagination: { page: 1, pageSize: 10000 }) {
      data {
        id
        attributes {
          value
        }
      }
    }
  }
`;

export const BED2ROLES = gql`
  query {
    bed2Ranges(pagination: { page: 1, pageSize: 10000 }) {
      data {
        id
        attributes {
          value
        }
      }
    }
  }
`;

export const INTROLES = gql`
  query {
    intRanges(pagination: { page: 1, pageSize: 10000 }) {
      data {
        id
        attributes {
          value
        }
      }
    }
  }
`;

export const VACROLES = gql`
  query {
    vacRanges(pagination: { page: 1, pageSize: 10000 }) {
      data {
        id
        attributes {
          value
        }
      }
    }
  }
`;

export const NHCROLES = gql`
  query {
    nhcRanges(pagination: { page: 1, pageSize: 10000 }) {
      data {
        id
        attributes {
          value
        }
      }
    }
  }
`;

export const LNKIROLES = gql`
  query {
    lnkIRanges(pagination: { page: 1, pageSize: 10000 }) {
      data {
        id
        attributes {
          value
        }
      }
    }
  }
`;

export const LNKNROLES = gql`
  query {
    lnkNRanges(pagination: { page: 1, pageSize: 10000 }) {
      data {
        id
        attributes {
          value
        }
      }
    }
  }
`;

export const LNKRROLES = gql`
  query {
    lnkRRanges(pagination: { page: 1, pageSize: 10000 }) {
      data {
        id
        attributes {
          value
        }
      }
    }
  }
`;

export const IEVRROLES = gql`
  query {
    ievRRanges(pagination: { page: 1, pageSize: 10000 }) {
      data {
        id
        attributes {
          value
        }
      }
    }
  }
`;

export const IEVNROLES = gql`
  query {
    ievNRanges(pagination: { page: 1, pageSize: 10000 }) {
      data {
        id
        attributes {
          value
        }
      }
    }
  }
`;

export const IEVIROLES = gql`
  query {
    ievIRanges(pagination: { page: 1, pageSize: 10000 }) {
      data {
        id
        attributes {
          value
        }
      }
    }
  }
`;
export const IEVCROLES = gql`
  query {
    ievCRanges(pagination: { page: 1, pageSize: 10000 }) {
      data {
        id
        attributes {
          value
        }
      }
    }
  }
`;

export const COPROLES = gql`
  query {
    copRanges(pagination: { page: 1, pageSize: 10000 }) {
      data {
        id
        attributes {
          value
        }
      }
    }
  }
`;

export const COPRROLES = gql`
  query {
    copRRanges(pagination: { page: 1, pageSize: 10000 }) {
      data {
        id
        attributes {
          value
        }
      }
    }
  }
`;

export const NTWUROLES = gql`
  query {
    ntwURanges(pagination: { page: 1, pageSize: 10000 }) {
      data {
        id
        attributes {
          value
        }
      }
    }
  }
`;

export const NTWSROLES = gql`
  query {
    ntwSRanges(pagination: { page: 1, pageSize: 10000 }) {
      data {
        id
        attributes {
          value
        }
      }
    }
  }
`;

export const NTWBROLES = gql`
  query {
    ntwBRanges(pagination: { page: 1, pageSize: 10000 }) {
      data {
        id
        attributes {
          value
        }
      }
    }
  }
`;
export const CONROLES = gql`
  query {
    conRanges(pagination: { page: 1, pageSize: 10000 }) {
      data {
        id
        attributes {
          value
        }
      }
    }
  }
`;

export const ISCROLES = gql`
  query {
    iscRanges(pagination: { page: 1, pageSize: 10000 }) {
      data {
        id
        attributes {
          value
        }
      }
    }
  }
`;

export const EXPROLES = gql`
  query {
    expRanges(pagination: { page: 1, pageSize: 10000 }) {
      data {
        id
        attributes {
          value
        }
      }
    }
  }
`;
export const STFROLES = gql`
  query {
    stFRanges(pagination: { page: 1, pageSize: 10000 }) {
      data {
        id
        attributes {
          value
        }
      }
    }
  }
`;
export const FSCROLES = gql`
  query {
    fscRanges(pagination: { page: 1, pageSize: 10000 }) {
      data {
        id
        attributes {
          value
        }
      }
    }
  }
`;
export const VC1ROLES = gql`
  query {
    vc1Ranges(pagination: { page: 1, pageSize: 10000 }) {
      data {
        id
        attributes {
          value
        }
      }
    }
  }
`;
export const VC2ROLES = gql`
  query {
    vc2Ranges(pagination: { page: 1, pageSize: 10000 }) {
      data {
        id
        attributes {
          value
        }
      }
    }
  }
`;
export const VC3ROLES = gql`
  query {
    vc3Ranges(pagination: { page: 1, pageSize: 10000 }) {
      data {
        id
        attributes {
          value
        }
      }
    }
  }
`;
export const VC4ROLES = gql`
  query {
    vc4Ranges(pagination: { page: 1, pageSize: 10000 }) {
      data {
        id
        attributes {
          value
        }
      }
    }
  }
`;
export const VC5ROLES = gql`
  query {
    vc5Ranges(pagination: { page: 1, pageSize: 10000 }) {
      data {
        id
        attributes {
          value
        }
      }
    }
  }
`;
export const VC6ROLES = gql`
  query {
    vc6Ranges(pagination: { page: 1, pageSize: 10000 }) {
      data {
        id
        attributes {
          value
        }
      }
    }
  }
`;
export const MMEROLES = gql`
  query {
    mmeRanges(pagination: { page: 1, pageSize: 10000 }) {
      data {
        id
        attributes {
          value
        }
      }
    }
  }
`;
export const RVNROLES = gql`
  query {
    rvnRanges(pagination: { page: 1, pageSize: 10000 }) {
      data {
        id
        attributes {
          value
        }
      }
    }
  }
`;

export const RVN1ROLES = gql`
  query {
    rvn1Ranges(pagination: { page: 1, pageSize: 10000 }) {
      data {
        id
        attributes {
          value
        }
      }
    }
  }
`;

export const PFTROLES = gql`
  query {
    pftRanges(pagination: { page: 1, pageSize: 10000 }) {
      data {
        id
        attributes {
          value
        }
      }
    }
  }
`;
export const PFT1ROLES = gql`
  query {
    pft1Ranges(pagination: { page: 1, pageSize: 10000 }) {
      data {
        id
        attributes {
          value
        }
      }
    }
  }
`;
export const BSTCROLES = gql`
  query {
    bstCRanges(pagination: { page: 1, pageSize: 10000 }) {
      data {
        id
        attributes {
          value
        }
      }
    }
  }
`;
export const BSTFROLES = gql`
  query {
    bstFRanges(pagination: { page: 1, pageSize: 10000 }) {
      data {
        id
        attributes {
          value
        }
      }
    }
  }
`;

export const AHS = gql`
  query {
    ahsRanges(pagination: { page: 1, pageSize: 10000 }) {
      data {
        id
        attributes {
          value
        }
      }
    }
  }
`;

export const FRM = gql`
  query {
    frmRanges(pagination: { page: 1, pageSize: 10000 }) {
      data {
        id
        attributes {
          value
        }
      }
    }
  }
`;

export const FAG = gql`
  query {
    fagRanges(pagination: { page: 1, pageSize: 10000 }) {
      data {
        id
        attributes {
          value
        }
      }
    }
  }
`;

export const WFW = gql`
  query {
    wfwRanges(pagination: { page: 1, pageSize: 10000 }) {
      data {
        id
        attributes {
          value
        }
      }
    }
  }
`;

export const FDN = gql`
  query {
    fdnRanges(pagination: { page: 1, pageSize: 10000 }) {
      data {
        id
        attributes {
          value
        }
      }
    }
  }
`;

export const WDW = gql`
  query {
    wdwRanges(pagination: { page: 1, pageSize: 10000 }) {
      data {
        id
        attributes {
          value
        }
      }
    }
  }
`;

export const MCN = gql`
  query {
    mcnRanges(pagination: { page: 1, pageSize: 10000 }) {
      data {
        id
        attributes {
          value
        }
      }
    }
  }
`;

export const MAN = gql`
  query {
    manRanges(pagination: { page: 1, pageSize: 10000 }) {
      data {
        id
        attributes {
          value
        }
      }
    }
  }
`;
export const DOEROLES = gql`
  query {
    doeRanges(pagination: { page: 1, pageSize: 10000 }) {
      data {
        id
        attributes {
          value
        }
      }
    }
  }
`;

export const DSEROLES = gql`
  query {
    dseRanges(pagination: { page: 1, pageSize: 10000 }) {
      data {
        id
        attributes {
          value
        }
      }
    }
  }
`;

export const NRIROLES = gql`
  query {
    nriRanges(pagination: { page: 1, pageSize: 10000 }) {
      data {
        id
        attributes {
          value
        }
      }
    }
  }
`;

export const STSROLES = gql`
  query {
    stSRanges(pagination: { page: 1, pageSize: 10000 }) {
      data {
        id
        attributes {
          value
        }
      }
    }
  }
`;

export const VC8ROLES = gql`
  query {
    vc8Ranges(pagination: { page: 1, pageSize: 10000 }) {
      data {
        id
        attributes {
          value
        }
      }
    }
  }
`;

export const WNFROLES = gql`
  query {
    wnfRanges(pagination: { page: 1, pageSize: 10000 }) {
      data {
        id
        attributes {
          value
        }
      }
    }
  }
`;
